export const toggleSelection = <T extends string>(
    selected: T | null,
    value: T,
): T | null => (selected === value ? null : value);
